import axios from "axios";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_COMMENT_DETAILS: "applications/FETCH_COMMENT_DETAILS",
  FETCH_COMMENTS_LIST: "applications/FETCH_COMMENTS_LIST",
  FETCH_COMMENT_OPTIONS: "applications/FETCH_COMMENT_OPTIONS",
  SAVE_COMMENT: "applications/SAVE_COMMENT",
};

const initialState = {
  loading: false,
  commentsList: [],
  commentDetails: null,
};

export type ApplicationCommentsState = Readonly<typeof initialState>;

/**
 * ApplicationComments Reducer
 */
export default (state: ApplicationCommentsState = initialState, action): ApplicationCommentsState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_COMMENT_DETAILS):
    case PENDING(ACTION_TYPES.FETCH_COMMENTS_LIST):
    case PENDING(ACTION_TYPES.FETCH_COMMENT_OPTIONS):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_COMMENTS_LIST): {
      return {
        ...state,
        loading: false,
        commentsList: action.payload.data,
      };
    }

    case FULFILLED(ACTION_TYPES.FETCH_COMMENT_DETAILS):
      return { ...state, loading: false, commentDetails: action.payload.data };

    case FULFILLED(ACTION_TYPES.FETCH_COMMENT_OPTIONS):
      return { ...state, loading: false, commentDetails: action.payload.data };

    case REJECTED(ACTION_TYPES.FETCH_COMMENT_DETAILS):
    case REJECTED(ACTION_TYPES.FETCH_COMMENTS_LIST):
    case REJECTED(ACTION_TYPES.FETCH_COMMENT_OPTIONS):
      return { ...state, loading: false };

    default:
      return state;
  }
};

/**
 * Actions for fetching comments data
 */
export const fetchAppCommentsList = ({ appId, page, rows, sort, query }) => ({
  type: ACTION_TYPES.FETCH_COMMENTS_LIST,
  meta: { listOptions: { page, rows, sort, query } },
  payload: axios.get(`applications/comments`, {
    params: { moduleId: 1, keyId: appId, rows, page, sort, ...query },
  }),
});

export const fetchAppCommentDetails = (commentId: string) => ({
  type: ACTION_TYPES.FETCH_COMMENT_DETAILS,
  payload: axios.get(`applications/comments/${commentId}?moduleId=1`),
});

export const fetchAppCommentOptions = () => ({
  type: ACTION_TYPES.FETCH_COMMENT_OPTIONS,
  payload: axios.get("applications/comments/new?moduleId=1"),
});

/**
 * Actions for saving comments data
 */
export const saveAppComment = (appID, userID, payload) => ({
  type: ACTION_TYPES.SAVE_COMMENT,
  payload: axios.post(`applications/comments?moduleId=1`, { applicationId: appID, createdBy: userID, ...payload }),
});
